import type { AuditEvent } from "../types";

export function ActivityTimeline({
  events,
  compact = false
}: {
  events: AuditEvent[];
  compact?: boolean;
}) {
  return (
    <div className={`activity-timeline ${compact ? "activity-timeline--compact" : ""}`}>
      <h2>Shared activity</h2>
      <ol>
        {events.slice(0, compact ? 3 : 20).map((event) => (
          <li key={event.id}>
            <time dateTime={new Date(event.occurredAt).toISOString()}>
              {new Intl.DateTimeFormat([], {
                hour: "numeric",
                minute: "2-digit",
                second: compact ? undefined : "2-digit"
              }).format(event.occurredAt)}
            </time>
            <span className="timeline-dot" />
            <span>
              <strong>{event.summary}</strong>
              {!compact && (
                <small>{event.actorName ? `${event.actorName} • ${event.actorRole}` : "System safety event"}</small>
              )}
            </span>
          </li>
        ))}
        {events.length === 0 && <li className="timeline-empty">No session activity yet.</li>}
      </ol>
    </div>
  );
}
